import pick from 'lodash/pick';

import { AccountSlugs } from 'Types/account';
import { PurchasesCompleteStatusTypes } from 'Types/purchaseCompleteStatus';

import { SOLD_CATEGORY } from '../../../utilities/vehicleState';

const soldCategories = Object.values(SOLD_CATEGORY);

export const counts = (data = {}) => ({
	[AccountSlugs.ACTIVE]: data.getActiveBidsForDealer,
	[AccountSlugs.UNDER_OFFER]: data.getUnderOfferBidsForDealer,
	[AccountSlugs.DIDNT_WIN]: data.getDidNotWinBidsForDealer,
	[AccountSlugs.COMPLETE]: data.getPurchasesCompleteBidsForDealer,
	[AccountSlugs.CANCELLED]: data.getPurchasesCancelledForDealer,
});

export const statusCounts = (data = {}) => ({
	[PurchasesCompleteStatusTypes.All]: data['all-statuses'],
	[PurchasesCompleteStatusTypes.AwaitingConfirmation]: data['awaiting-confirmation'],
	[PurchasesCompleteStatusTypes.ChecksComplete]: data['checks-complete'],
	[PurchasesCompleteStatusTypes.DeliveryRequested]: data['transport-requested'],
	[PurchasesCompleteStatusTypes.ReviewingDocs]: data['reviewing-docs'],
});

const accountVehicleBaseMapperForBiddingEndpoints = ({ vehicle = {} }) => {
	const isSold = soldCategories.includes(vehicle.vehicleStateSlug);

	return {
		...pick(vehicle, [
			'enquiryId',
			'enquirySoldDate',
			'isDelivered',
			'make',
			'model',
			'isVatQualifying',
			'brokerFeeAmount',
			'finalOfferAmount',
			'totalPaymentAmount',
			'transportFeeAmount',
			'mechanicalGuaranteeFeeAmount',
			'mechanicalGuaranteePromotionalRate',
			'transportMetadata',
		]),
		hasFees: Boolean(vehicle.brokerFeeAmount || vehicle.transportFeeAmount),
		id: vehicle.enquiryId,
		isTrade: Boolean(vehicle.isTrade),
		leadPhoto: {
			url: vehicle.vehicleImageUrl,
		},
		prettyVrm: vehicle.vrm,
		soldFor: isSold ? vehicle.displayPrice : null,
		state: {
			slug: vehicle.vehicleStateSlug,
			transportRequested: vehicle.transportRequested,
		},
		userBid: {
			createdAt: vehicle.createdAt,
			dealerContactId: vehicle.dealerContactId,
			id: vehicle.bidId,
			maximumBid: vehicle.maxBidValue,
			state: vehicle.bidState,
			type: vehicle.bidType,
			value: vehicle.bidValue,
		},
		winningBid: vehicle.maxClosingBidValue,
	};
};

export const accountSection = ({ vehicles = {} }) => ({
	count: vehicles.count,
	results: vehicles.results.map((vehicle) => accountVehicleBaseMapperForBiddingEndpoints({ vehicle })),
});
